import {ReactElement, useEffect, useState} from "react";
import {Dropdown, Multiselect, Field, Menu, Item} from '@zendeskgarden/react-dropdowns';
import {Property} from "../../../contexts/properties/PropertiesContext";
import Downshift from "downshift";
import {Button} from "@zendeskgarden/react-buttons";
import * as css from "../styles/propertyManagement.module.scss";
import {Tag} from "@zendeskgarden/react-tags";
import {MONTHS} from "../../../constants/Months";

export interface IPropertyDropdownProps {
    selectedProperties: string[];
    properties: Property[];
    onPropertySelect: (selected: string[]) => void;
}

export default function PropertyDropdown({selectedProperties, properties, onPropertySelect}: IPropertyDropdownProps): ReactElement {
    const [inputValue, setInputValue] = useState("");
    const [filteredProperties, setFilteredProperties] = useState<Property[]>(properties);

    useEffect(() => {
        setFilteredProperties(properties.filter(p => p.name.toLowerCase().includes(inputValue.trim().toLowerCase())));
    }, [inputValue, properties]);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const stateReducer = (state: any, changes: any) => {
        switch (changes.type) {
            case Downshift.stateChangeTypes.keyDownEnter:
            case Downshift.stateChangeTypes.clickItem:
                return {
                    ...changes,
                    highlightedIndex: state.highlightedIndex,
                    isOpen: true,
                    inputValue: '',
                };
            default:
                return changes;
        }
    };

    return (
        <Dropdown
            inputValue={inputValue}
            selectedItems={selectedProperties}
            onSelect={items => onPropertySelect(items)}
            downshiftProps={{defaultHighlightedIndex: 0, stateReducer}}
            onInputValueChange={value => setInputValue(value)}
        >
            <Field>
                <Multiselect
                    placeholder="Select Properties"
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    renderItem={({value, removeValue}: any) => (
                        <Tag>
                            <span>{properties.find(p => p.id == value)?.name}</span>
                            <Tag.Close onClick={() => removeValue()} />
                        </Tag>
                    )}
                />
            </Field>
            <Menu>
                {inputValue == "" &&
                    <Button
                        className={css.propertyDropdownSelectAll}
                        isBasic
                        onClick={() => {
                            onPropertySelect(
                                selectedProperties.length === properties.length ? [] : properties.map(p => p.id)
                            );
                        }}
                    >
                        {selectedProperties.length === properties.length ? "Deselect All" : "Select All"}
                    </Button>
                }

                {(inputValue != "" && filteredProperties.length == 0) &&
                    <Item className={css.propertyDropdownItem} disabled>No items found</Item>
                }

                {filteredProperties.map(p => (
                    <Item
                        key={p.id}
                        value={p.id}
                        className={css.propertyDropdownItem}
                    >
                        <span>{p.name}</span>
                        <div className={css.propertyDropdownTags}>
                            <Tag className={`${css.tag} ${css.isActive}`}>
                                <span>{`${p.reforecastYear}-${MONTHS[p.reforecastStartMonthIndex]}`}</span>
                            </Tag>
                        </div>
                    </Item>
                ))}
            </Menu>
        </Dropdown>
    );
}
